import { FC } from "react";
import AdminEditor from "./../AdminEditor";
import { Item, ItemProps } from ".";

interface EditorProps extends ItemProps {
    value?: string;
    onChange?: (value?: string) => void;
}
const Editor: FC<EditorProps> = ({ value, onChange, col, error, label, required, itemClassName, helper }) => {
    return <Item col={col} label={label} required={required} error={error} itemClassName={itemClassName} helper={helper}>
        <AdminEditor
            value={value || ""}
            onChange={onChange}
        />
    </Item >
}

export default Editor;